import React from "react";

export default function PriorityRenderer(props) {
  const { value } = props;

  // Only show red flag when priority is "high"
  if (!value || value.toLowerCase() !== 'high') {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <i
        className="fa-solid fa-flag"
        style={{
          color: '#dc3545',
          fontSize: '16px',
        }}
      ></i>
    </div>
  );
}